import { render, staticRenderFns } from "./GroupBuyConfigPane.vue?vue&type=template&id=25159e32&scoped=true"
import script from "./GroupBuyConfigPane.vue?vue&type=script&lang=js"
export * from "./GroupBuyConfigPane.vue?vue&type=script&lang=js"
import style0 from "./GroupBuyConfigPane.vue?vue&type=style&index=0&id=25159e32&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25159e32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25159e32')) {
      api.createRecord('25159e32', component.options)
    } else {
      api.reload('25159e32', component.options)
    }
    module.hot.accept("./GroupBuyConfigPane.vue?vue&type=template&id=25159e32&scoped=true", function () {
      api.rerender('25159e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/group_buy/GroupBuyConfigPane.vue"
export default component.exports